<template>
    <div class="card-select-product-box">
        <el-button type="text" @click="selectProState = true" v-if="!disabled">{{addName}}</el-button>
        <div class="selected-table">
            <el-table :data="selectedList" height="250px" v-if="selectedList.length > 0">
                <el-table-column prop="name" label="服务名称" width="180" />
                <el-table-column prop="num" label="次数" width="180" v-if="countType!=='3'">
                    <template slot-scope="scope">
                        <span v-if="countType === '2'">不限</span>
                        <el-input v-model="scope.row.num" style="width: 100px" @keyup="returnEvent" :disabled="disabled" v-else>
                            <span slot="suffix" class="suffix">次</span>
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deletePro(scope.$index)" v-if="!disabled">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pl-option" v-if="selectedList.length > 0 && (countType === '1' || countType === '3')">
            <div class="flex" v-if="countType === '1'">
                <div style="width: 200px;">批量设置:</div>
                <div class="flex-1">
                    <el-input v-model="plValue" style="width: 200px" :disabled="disabled">
                        <span slot="append">次</span>
                    </el-input>
                </div>
            </div>
            <div class="pl-text" v-else-if="countType === '3'">
                以上{{selectedList.length}}个服务总次数:共 <el-input v-model="alValue" style="width: 50px" /> 次
                每次划卡时可以从以上项目中任选一个， 并划扣总次数1次
            </div>
        </div>

        <!--选择权益-->
        <select-product v-model="selectProState" :pro-type="1" @done="selectedProDone" title="选择" :selected-list="selectedList" />
    </div>
</template>

<script>
    import SelectProduct from "@/model/StoreUser/SelectProduct";
    export default {
        name: "CardSelectProduct",
        components: {SelectProduct},
        model: {
            prop: "data",
            event: "dataChange"
        },
        props: {
            data: {
                type: Object,
                default: () => ({}),
            },
            countType: {
                type: String,
                default: "1"
            },
            addName: {
                type: String,
                default: "点击添加项目"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            selectProState: false,
            selectedList: [],   //选择的数据
            returnData: {
                count_max_num: 0,
                product_list: [],
            },     //返回的数据
            plValue: "",    //批量设置数量
            alValue: "",    //总量
            isInit: false,  //是否初始化
        }),
        mounted: function () {
            this.initData();
        },
        methods: {
            initData: function () {
                this.isInit = true;
                this.alValue = this.data.count_max_num;
                this.selectedList = this.data.product_list ? this.data.product_list : [];
                this.$nextTick( () => {
                    this.isInit = false;
                });
            },
            //选择结果
            selectedProDone: function (proList) {
                proList.forEach( v => {
                    this.selectedList.push({
                        id: v.id,
                        name: v.title,
                        num: "1",
                    });
                });
                this.returnEvent();
            },
            //删除选择的项目
            deletePro: function (index) {
                this.selectedList.splice(index, 1);
                this.returnEvent();
            },
            //批量设置变化
            handlePlValueChange: function () {
                if(this.selectedList.length <= 0 || this.countType === "2" || this.isInit)
                    return false;

                if(this.countType==="1"){
                    //批量设置
                    this.selectedList.forEach((v, i) => {
                        let val = {...v};
                        val.num = this.plValue;
                        this.selectedList.splice(i, 1, val);
                    });
                } else {
                    this.returnData.count_max_num = this.alValue;
                }
                this.returnEvent();
            },
            //返回数据
            returnEvent: function () {
                this.returnData.product_list = this.selectedList;
                this.$emit("dataChange", this.returnData);
            }
        },
        watch: {
            plValue: function () {
                this.handlePlValueChange();
            },
            alValue: function () {
                this.handlePlValueChange();
            },
            "data": function () {
                this.initData();
            }
        }
    }
</script>

<style scoped>
    .el-table::before{
        height: 0;
    }
    .selected-table{
        padding: 0px 5px;
        background: #FAFAFA;
    }
    .selected-table .el-table{
        background: #FAFAFA;
        width: 100%;
    }
    .suffix{
        line-height: 40px;
    }
    .pl-option{
        background: #FAFAFA;
        padding: 5px;
        margin-top: 5px;
        border-left: 5px solid #eae9ea;
    }
    .pl-option .pl-text{
        color: #777777;
    }
</style>
<style>
    .card-select-product-box .el-table th, .card-select-product-box .el-table tr{
        background-color: transparent;
    }
    .card-select-product-box .el-table td, .card-select-product-box .el-table th{
        padding: 5px 0;
    }
    .card-select-product-box .el-input-group__append, .card-select-product-box .el-input-group__prepend{
        background-color: #F5F7FA;
        border-color: #DCDFE6;
        color: #606266;
    }
</style>
